import React, { useState } from "react";

const AddressInput = ({ label, placeholder, helpIcon, value, onChange }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap');

        .ai-wrap {
          display: flex; flex-direction: column; gap: 6px;
          width: 100%; font-family: 'DM Sans', sans-serif;
        }

        .ai-label-row { display: flex; align-items: center; gap: 4px; }

        .ai-label {
          font-size: 12px; font-weight: 600; color: #475569;
        }

        .ai-required { color: #EF4444; font-size: 12px; margin-left: 1px; }

        .ai-input {
          width: 100%;
          padding: 9px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: #0F172A;
          background: #ffffff;
          border: 1px solid #E2E8F0;
          border-radius: 10px;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
          box-shadow: 0 1px 2px rgba(0,0,0,0.04);
        }

        .ai-input::placeholder { color: #94A3B8; }

        .ai-input:focus {
          border-color: #2563EB;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
      `}</style>

      <div className="ai-wrap">
        <div className="ai-label-row">
          <label className="ai-label">{label}</label>
          <span className="ai-required">*</span>
        </div>

        <input
          className="ai-input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </div>
    </>
  );
};

export default AddressInput;